import API from "core/api/axios/base";
import NumberListErrorHandler from "../handler/NumberListErrorHandler";

export default function ListNumberApi(token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + token,
      "x-accesstoken": token
    },
    withCredentials: true
  };
  config.headers['x-credentials-key'] = process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.get(`${process.env.REACT_APP_DEPENDENTE_NUMBER_LIST}`, config)
    .then(({ data: {data ={}} }) => {

      return data;
    })
    .catch((error) => {
      const errorHandler = NumberListErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
